import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import styled from 'styled-components';

import WelcomePageLayout from './WelcomePageLayout';

import { WelcomeRoutes } from 'utils/routeGenerator';

const Main = styled.main``;

const WelcomePage = () => {
  const location = useLocation();

  const memberLandingPage = matchPath(
    WelcomeRoutes.memberOnboarding(),
    location.pathname
  );

  return (
    <Main>
      <WelcomePageLayout memberLandingPage={memberLandingPage !== null} />
    </Main>
  );
};

export default WelcomePage;
